import React from "react";

export default function BleIcon(props: any) {
  return (
    <svg
      width="68"
      height="63"
      viewBox="0 0 68 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M56.627 46.6689L58.042 48.0839C71.319 34.8049 71.319 13.2779 58.042 -0.00012207L56.627 1.41388C69.1049 13.8909 69.1049 34.1919 56.627 46.6689Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34 14.0415C31.44 14.0415 28.882 15.0185 26.929 16.9705C23.023 20.8755 23.023 27.2075 26.929 31.1125C28.882 33.0655 31.44 34.0415 34 34.0415C36.56 34.0415 39.118 33.0655 41.071 31.1125C44.977 27.2075 44.977 20.8755 41.071 16.9705C39.118 15.0185 36.56 14.0415 34 14.0415ZM34 16.0415C36.137 16.0415 38.146 16.8735 39.657 18.3845C41.168 19.8955 42 21.9045 42 24.0415C42 26.1785 41.168 28.1875 39.657 29.6985C38.146 31.2095 36.137 32.0415 34 32.0415C31.863 32.0415 29.854 31.2095 28.343 29.6985C26.832 28.1875 26 26.1785 26 24.0415C26 21.9045 26.832 19.8955 28.343 18.3845C29.854 16.8735 31.863 16.0415 34 16.0415Z"
        fill="black"
      />
      <path
        d="M9.95799 0.00012207L11.373 1.41412C-1.10501 13.8911 -1.10501 34.1921 11.373 46.6691L9.95799 48.0831C-3.31901 34.8051 -3.31901 13.2781 9.95799 0.00012207Z"
        fill="black"
      />
      <path
        d="M15.6152 5.65668L14.2013 4.24268C3.26625 15.1777 3.26625 32.9057 14.2013 43.8407L15.6152 42.4267C5.47725 32.2887 5.47725 15.7947 15.6152 5.65668Z"
        fill="black"
      />
      <path
        d="M53.7988 43.8413L52.3848 42.4263C62.5228 32.2893 62.5228 15.7943 52.3848 5.65631L53.7988 4.24231C64.7338 15.1773 64.7338 32.9053 53.7988 43.8413Z"
        fill="black"
      />
      <path
        d="M19.8574 9.89935L18.4434 8.48535C9.85237 17.0764 9.85237 31.0064 18.4434 39.5984L19.8574 38.1833C12.0594 30.3854 12.0594 17.6974 19.8574 9.89935Z"
        fill="black"
      />
      <path
        d="M49.5566 39.5986L48.1426 38.1836C55.9406 30.3856 55.9406 17.6976 48.1426 9.8996L49.5566 8.4856C58.1476 17.0766 58.1476 31.0066 49.5566 39.5986Z"
        fill="black"
      />
      <path
        d="M43.8994 33.9409L45.3134 35.3559C51.5624 29.1069 51.5624 18.9759 45.3134 12.7279L43.8994 14.1419C49.3584 19.6009 49.3584 28.4829 43.8994 33.9409Z"
        fill="black"
      />
      <path
        d="M22.6866 12.7281L24.1006 14.1421C18.6416 19.6001 18.6416 28.4821 24.1006 33.9411L22.6866 35.3551C16.4376 29.1072 16.4376 18.9762 22.6866 12.7281Z"
        fill="black"
      />
      <path
        d="M27 62.0835V60.0835H33V34.0835H35V60.0835H41V62.0835H27Z"
        fill="black"
      />
    </svg>
  );
}
